import { render, staticRenderFns } from "./checkout-service.vue?vue&type=template&id=c38e1316&scoped=true&"
import script from "./checkout-service.vue?vue&type=script&lang=js&"
export * from "./checkout-service.vue?vue&type=script&lang=js&"
import style0 from "./checkout-service.vue?vue&type=style&index=0&id=c38e1316&lang=scss&scoped=false&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38e1316",
  null
  
)

export default component.exports